import { Observable } from 'rxjs/Observable';
import { AjaxRequest } from 'rxjs/observable/dom/AjaxObservable';
//@ts-ignore
import * as models from '../model/models';
import { RemoteData } from '@assetmark/ui-kit/dist/utils/remote-data.utils';
import { ObjectUtils } from '@assetmark/ui-kit/dist/utils/object.utils';

import { UserApiClient as ApiClient } from '../../apis/api.client';
//import isNotNullable = ObjectUtils.isNotNullable;

type TQueryParam = {
	key: string;
	value: string | string[] | boolean | number | Date | undefined;
};

// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace UserService {
	/**
	 *
	 * @summary Get token by sessionid
	 * @param apiVersion - The requested API version
	 */
	export function apiUserV1Get(apiVersion: string): Observable<RemoteData<models.User>> {
		const path = '/api/user/v1'.replace(/^\//, '').replace('{api-version}', String(apiVersion));
		const allQueryParams: TQueryParam[] = [];
		const queryParams = allQueryParams
			.filter(param => ObjectUtils.isNotNullable(param.value))
			.map(param => `${param.key}=${param.value}`)
			.join('&');
		const url = queryParams === '' ? path : path.concat(`?${queryParams}`);
		const ajaxRequest: AjaxRequest = {
			url,
			method: 'GET',
		};
		return ApiClient.request(ajaxRequest);
	}
}
